import { css } from '@emotion/core';
import { colorsPalette } from '../../../styles/colors';
import { typography, fontWeights } from '../../../styles/typography';
import { MediaQueries } from '../../../styles/Grid';

export const onlyLgAndUpCss = css({
  display: 'none',
  [MediaQueries.lgAndUp]: {
    display: 'block',
  },
});

export const onlyMdAndBelowCss = css({
  display: 'block',
  [MediaQueries.lgAndUp]: {
    display: 'none',
  },
});

export const stickyElementCss = css({
  position: 'sticky',
  zIndex: 1,
});

export const layoutContainerCss = css({
  // Fix issue where the first component has margin and affects the position of the parent.
  // overflow: auto also fixes the issue, but affects the sticky functionality.
  paddingTop: 1,
  marginTop: -1,
  paddingBottom: 1,
  marginBottom: -1,
  position: 'relative',
});

// Use an extra element with absolute to avoid modifying the flow
// of the elements at the right.
export const stickyParentCss = css({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  alignItems: 'flex-end',
  position: 'absolute',
  zIndex: 1,
  width: '100%',
  height: '100%',
  pointerEvents: 'none',
});

export const stickyContainerCss = css(stickyElementCss, {
  top: 0,
  paddingTop: 110,
  paddingBottom: 200,
});

export const headlineCss = css(typography.effra16, {
  fontWeight: fontWeights.medium,
  color: colorsPalette.grey,
  marginBottom: 15,
});

export const sectionCss = css(typography.effra16, {
  color: colorsPalette.red,
});

export const subsectionCss = css(typography.effra16, {
  color: colorsPalette.grey80,
});

export const textContainerCss = css({
  pointerEvents: 'all',
  marginBottom: 45,
});

export const stickyBackToTopCss = css(stickyElementCss, {
  paddingRight: 25,
  paddingBottom: 15,
  bottom: 15,
});

export const stickyProgressBar = css(stickyElementCss, {
  top: 0,
});
